var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27030_226122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.3999 16C32.3999 7.16344 25.2365 0 16.3999 0C7.56335 0 0.399902 7.16344 0.399902 16C0.399902 24.8366 7.56335 32 16.3999 32C25.2365 32 32.3999 24.8366 32.3999 16Z",
    fill: "url(#paint0_linear_27030_226122)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5666 20.167H17.2333V15.167H15.5666V20.167ZM16.4 13.5003C16.6361 13.5003 16.834 13.4205 16.9937 13.2607C17.1535 13.101 17.2333 12.9031 17.2333 12.667C17.2333 12.4309 17.1535 12.233 16.9937 12.0732C16.834 11.9135 16.6361 11.8337 16.4 11.8337C16.1639 11.8337 15.966 11.9135 15.8062 12.0732C15.6465 12.233 15.5666 12.4309 15.5666 12.667C15.5666 12.9031 15.6465 13.101 15.8062 13.2607C15.966 13.4205 16.1639 13.5003 16.4 13.5003ZM16.4 24.3337C15.2472 24.3337 14.1639 24.1149 13.15 23.6774C12.1361 23.2399 11.2541 22.6462 10.5041 21.8962C9.75415 21.1462 9.1604 20.2642 8.7229 19.2503C8.2854 18.2364 8.06665 17.1531 8.06665 16.0003C8.06665 14.8475 8.2854 13.7642 8.7229 12.7503C9.1604 11.7364 9.75415 10.8545 10.5041 10.1045C11.2541 9.35449 12.1361 8.76074 13.15 8.32324C14.1639 7.88574 15.2472 7.66699 16.4 7.66699C17.5528 7.66699 18.6361 7.88574 19.65 8.32324C20.6639 8.76074 21.5458 9.35449 22.2958 10.1045C23.0458 10.8545 23.6396 11.7364 24.0771 12.7503C24.5146 13.7642 24.7333 14.8475 24.7333 16.0003C24.7333 17.1531 24.5146 18.2364 24.0771 19.2503C23.6396 20.2642 23.0458 21.1462 22.2958 21.8962C21.5458 22.6462 20.6639 23.2399 19.65 23.6774C18.6361 24.1149 17.5528 24.3337 16.4 24.3337ZM16.4 22.667C18.2611 22.667 19.8375 22.0212 21.1291 20.7295C22.4208 19.4378 23.0666 17.8614 23.0666 16.0003C23.0666 14.1392 22.4208 12.5628 21.1291 11.2712C19.8375 9.97949 18.2611 9.33366 16.4 9.33366C14.5389 9.33366 12.9625 9.97949 11.6708 11.2712C10.3792 12.5628 9.73331 14.1392 9.73331 16.0003C9.73331 17.8614 10.3792 19.4378 11.6708 20.7295C12.9625 22.0212 14.5389 22.667 16.4 22.667Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_27030_226122",
    x1: 16.3999,
    y1: 0,
    x2: 16.3999,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#994E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8217"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27030_226122"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.399902)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDue);
export default __webpack_public_path__ + "static/media/due.49089f897a22d3b9e632ecbaaf54dfd3.svg";
export { ForwardRef as ReactComponent };